import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import FileSpinner from '../styled/file-spinner';
import { maxFileNameLength, UploadBarWrapper, UploadBar, ProgressBar, FileName, RemoveButton } from './styled';
import LoadingSpinner from '../loading-spinner';
const UploadsView = _ref => {
  let {
    descriptor,
    theme,
    abort,
    hasError,
    isDone
  } = _ref;
  const percentileWidth = descriptor.progress && descriptor.total ? Math.floor(descriptor.progress / descriptor.total * 100) : null;
  const statusIcon = hasError ? faExclamationTriangle : isDone ? faCheck : null;
  const fileName = descriptor.name.length > maxFileNameLength ? `${descriptor.name.slice(0, maxFileNameLength - 3)}...` : descriptor.name;
  const statusColor = hasError ? theme.colors.error : theme.colors.primary;
  return /*#__PURE__*/React.createElement(UploadBarWrapper, {
    key: descriptor.id,
    progress: percentileWidth
  }, /*#__PURE__*/React.createElement(UploadBar, null, /*#__PURE__*/React.createElement(ProgressBar, {
    progress: percentileWidth,
    isError: hasError
  })), /*#__PURE__*/React.createElement(FileName, null, fileName), /*#__PURE__*/React.createElement(FileSpinner, null, isDone || hasError ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: statusIcon,
    size: "lg",
    color: statusColor,
    fixedWidth: true
  }) : /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 15
  })), /*#__PURE__*/React.createElement(RemoveButton, {
    onClick: abort,
    disabled: percentileWidth === 100 && !hasError
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimesCircle,
    size: "lg",
    color: theme.colors.tertiary,
    fixedWidth: true
  })));
};
UploadsView.propTypes = {
  descriptor: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  hasError: PropTypes.bool.isRequired,
  abort: PropTypes.func.isRequired,
  isDone: PropTypes.bool.isRequired
};
export default withTheme(UploadsView);